import { CHECK_TOKEN_REQUEST, CHECK_TOKEN_SUCCESS, CHECK_TOKEN_ERROR } from '../../actions/auth';
import { Map } from "immutable";

const auth = (state, action = {}) => {
    state = state || Map({
            isFetching: false,
            success: false,
            error: false,
            errorCode: '',
            payload: null
    });

    let newState;

    switch (action.type) {
        case CHECK_TOKEN_REQUEST:
            newState = state.merge({
                isFetching: action.isFetching,
                error: action.error
            });
            break;
        case CHECK_TOKEN_SUCCESS:
            newState = state.merge({
                isFetching: action.isFetching,
                success: action.success,
                error: action.error
            });
            break;
        case CHECK_TOKEN_ERROR:
            newState = state.merge({
                isFetching: action.isFetching,
                error: action.error,
                errorMessage: action.errorMessage
            });
            break;
        default:
            newState = state;
    }

    return newState;
};

export default auth;



// WEBPACK FOOTER //
// ./src/reducers/auth/checkToken.js